import { render, staticRenderFns } from "./Devis.vue?vue&type=template&id=4f5d5402&scoped=true"
import script from "./Devis.vue?vue&type=script&lang=js"
export * from "./Devis.vue?vue&type=script&lang=js"
import style0 from "./Devis.vue?vue&type=style&index=0&id=4f5d5402&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4f5d5402",
  null
  
)

export default component.exports